// Module
var code = "<h2 id=\"update-your-account-information\">Update Your Account Information</h2> <p>Step-by-step instructions for updating your contact information, changing your name, and more.</p> ";
// Exports
export default code;